export class IndicatorParam {
  idIndicatorParam: number;
  idIndicator: number;
  name: string;
  type: string;
  index: number | null;
  defaultValue: string | null;

  constructor(
    idIndicatorParam: number,
    idIndicator: number,
    name: string,
    type: string,
    index: number | null,
    defaultValue: string | null,
  ) {
    this.idIndicatorParam = idIndicatorParam;
    this.idIndicator = idIndicator;
    this.name = name;
    this.type = type;
    this.index = index;
    this.defaultValue = defaultValue;
  }

  static fromRaw(raw: any): IndicatorParam {
    return new IndicatorParam(
      raw.idIndicatorParam,
      raw.idIndicator,
      String(raw.name),
      String(raw.type),
      raw.index !== undefined && raw.index !== null ? Number(raw.index) : null,
      raw.defaultValue ?? null,
    );
  }

  clone(): IndicatorParam {
    return new IndicatorParam(
      this.idIndicatorParam,
      this.idIndicator,
      this.name,
      this.type,
      this.index,
      this.defaultValue,
    );
  }

  toPayload(): any {
    const payload: any = {
      idIndicator: this.idIndicator,
      name: this.name,
      type: this.type,
    };
    if (this.index !== null) {
      payload.index = this.index;
    }
    if (this.defaultValue !== null) {
      payload.defaultValue = this.defaultValue;
    }
    if (this.idIndicatorParam !== null) {
      payload.idIndicatorParam = this.idIndicatorParam;
    }
    return payload;
  }
}
